import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetCardComponent, AssetCardData } from '../asset-card/asset-card.component';
import { FeatureCardComponent, FeatureCardData } from '../feature-card/feature-card.component';
import { ModelCardComponent, ModelCardData } from '../model-card/model-card.component';
import { CarouselComponent } from '../primeng/carousel/carousel.component';

@Component({
  selector: 'app-similar-datasets',
  standalone: true,
  imports: [CommonModule, AssetCardComponent, FeatureCardComponent, ModelCardComponent, CarouselComponent],
  templateUrl: './similar-datasets.component.html',
  styleUrl: './similar-datasets.component.scss'
})
export class SimilarDatasetsComponent {
  /** Legacy asset cards (e.g. usecases). */
  @Input() datasets: AssetCardData[] = [];
  /** Dataset cards — same component as the Datasets Collection page. */
  @Input() featureCards: FeatureCardData[] = [];
  /** Model cards — same component as the Models Collection page. */
  @Input() models: ModelCardData[] = [];
  @Input() title: string = 'Similar Datasets';
  @Input() assetType: 'dataset' | 'model' | 'usecase' = 'dataset';
  @Input() itemsToShow: number = 3;
  @Input() showDots: boolean = true;
  @Input() showArrows: boolean = true;
  @Input() gap: number = 24;

  get hasItems(): boolean {
    if (this.assetType === 'model') {
      return this.models.length > 0;
    }
    if (this.assetType === 'dataset') {
      return this.featureCards.length > 0;
    }
    return this.datasets.length > 0;
  }

  get carouselItems(): AssetCardData[] | FeatureCardData[] | ModelCardData[] {
    if (this.assetType === 'model') {
      return this.models;
    }
    if (this.assetType === 'dataset') {
      return this.featureCards;
    }
    return this.datasets;
  }
}

